import React, { useState } from 'react'
import { Menu, MenuItem, Sidebar } from 'react-pro-sidebar'
import AddLocationAltOutlinedIcon from '@mui/icons-material/AddLocationAltOutlined';
import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';
import { useNavigate } from 'react-router-dom';
import { InboxOutlined, InboxRounded, SearchOffRounded, SearchRounded } from '@mui/icons-material';
import useActiveNavBar from '../hooks/useActiveNavbar';

export default function Layout({children}) {
    const navigate = useNavigate();
    const [activeTab, setActiveNavItem] = useActiveNavBar();
    const [collapsed, setCollapsed] = useState(true);
    // const [activeTab, setActiveTab] = useState("location");


    

    return (
        <div style={{ display: 'flex', height: '100%', minHeight: '100vh' }}>
            <Sidebar collapsed={collapsed}>
                <button className='h-20 w-full flex justify-center' onClick={() => setCollapsed(!collapsed)}>
                    <img className='flex align-middle justify-center mt-4' height={50} width={50} src={require('../assets/warehouse.png')} />
                </button>
                <hr/>
                <Menu
                    menuItemStyles={{
                        button: ({ level, active, disabled }) => {
                          // only apply styles on first level elements of the tree
                          if (level === 0)
                            return {
                              backgroundColor: active ? '#D3D3D3' : undefined,
                            };
                        },
                    }}
                >
                    <MenuItem active={activeTab === "find"} icon={<SearchRounded/>} onClick={()=>{navigate("/find"); setActiveNavItem("find")}}>
                        Find
                    </MenuItem>
                    <MenuItem active={activeTab === "stockin"} icon={<InboxOutlined/>} onClick={()=>{navigate("/stockin"); setActiveNavItem("stockin")}}>
                        Stock In
                    </MenuItem>
                    <MenuItem active={activeTab === "location"} icon={<AddLocationAltOutlinedIcon/>} onClick={()=>{navigate("/location"); setActiveNavItem("location")}}>
                        Location
                    </MenuItem>
                    <MenuItem active={activeTab === "inventory"} icon={<InventoryRoundedIcon/>} onClick={()=>{navigate("/inventory"); setActiveNavItem("inventory")}}>
                        Inventory
                    </MenuItem>
                </Menu>
            </Sidebar>
            <main style={{ padding: 10, flex:1 }}>
                {children}
            </main>
        </div>
    )
}
